var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305 283L305 269L286 284Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 284L281 297L305 283Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 269L270 252L286 284Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 284L238 291L281 297Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 297L294 321L305 283Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 269L296 229L270 252Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 229L283 230L270 252Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 335L348 280L305 283Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 283L348 280L305 269Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 269L318 216L296 229Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 281L238 291L225 271Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 252L238 291L286 284Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 297L244 341L294 321Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 342L316 335L252 365Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 321L316 335L305 283Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 280L354 251L305 269Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 251L318 216L305 269Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 229L313 201L283 230Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 281L231 299L238 291Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 291L244 341L281 297Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 271L238 291L270 252Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 335L332 335L305 283Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 248L225 271L270 252Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 365L316 335L294 321Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 335L321 342L332 335Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 335L366 285L348 280Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 280L373 263L354 251Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 192L313 201L318 216Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 216L313 201L296 229Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 209L209 248L270 252Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 285L373 263L348 280Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 178L317 192L318 216Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 299L244 341L238 291Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 271L212 282L226 281Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 281L212 282L231 299Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 299L231 351L244 341Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 299L379 292L366 285Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 285L388 271L373 263Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 335L378 299L366 285Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 219L318 216L354 251Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 201L284 175L283 230Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 271L209 248L212 282Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 245L354 251L373 263Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 238L364 219L354 251Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 209L270 252L226 193Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 271L382 245L373 263Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 293L388 271L379 292Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 292L388 271L366 285Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 245L381 238L354 251Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 209L381 238L406 233Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 330L231 351L231 299Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 341L252 365L294 321Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 351L252 365L244 341Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 192L284 175L313 201Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 374L384 327L332 335Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 335L384 327L378 299Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 299L393 319L379 292Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 387L332 335L321 342Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 219L334 178L318 216Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 192L307 171L284 175Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 168L334 178L380 190Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 178L307 171L317 192Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 193L270 252L283 230Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 327L393 319L378 299Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 175L226 193L283 230Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 327L396 322L393 319Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 319L437 293L379 292Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 295L194 330L212 282Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 282L194 330L231 299Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 351L207 360L252 365Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 258L212 282L209 248Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 233L381 238L382 245Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 238L389 209L364 219Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 233L382 245L388 271Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 217L181 258L209 248Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 190L334 178L364 219Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 146L317 144L307 171Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 176L193 217L212 209Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 209L193 217L209 248Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 228L406 233L438 269Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 144L296 157L307 171Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 171L296 157L284 175Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 175L257 161L226 193Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 330L197 346L231 351Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 191L380 190L389 209Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 209L380 190L364 219Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 156L257 161L284 175Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 193L200 176L212 209Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 346L207 360L231 351Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 258L173 295L212 282Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 330L171 352L197 346Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 157L260 156L284 175Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 157L200 176L226 193Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 187L387 191L389 209Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 190L343 155L342 168Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 412L321 342L252 365Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 412L355 387L321 342Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 327L413 331L396 322Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 356L413 331L384 327Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 318L437 293L393 319Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 162L343 155L380 190Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 146L307 171L334 178Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 157L297 126L260 156Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 387L368 384L332 335Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 384L385 374L332 335Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 258L163 293L173 295Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 295L171 352L194 330Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 294L163 293L147 254Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 269L406 233L388 271Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 233L420 228L389 209Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 146L334 178L342 168Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 141L333 146L343 155Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 155L333 146L342 168Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 254L163 293L181 258Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 293L159 294L173 295Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 346L171 352L207 360Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 157L226 193L257 161Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 217L163 211L181 258Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 420L323 412L252 365Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 387L391 414L368 384Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 414L419 356L385 374Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 210L403 187L389 209Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 191L404 162L380 190Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 130L333 141L343 155Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 146L333 141L317 144Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 176L173 206L193 217Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 119L241 144L260 156Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 156L241 144L257 161Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 126L296 157L317 144Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 144L216 157L257 161Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 176L198 170L173 206Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 318L393 319L396 322Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 293L438 269L388 271Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 228L432 210L389 209Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 159L198 170L200 176Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 331L433 318L396 322Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 331L433 318L413 331Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 356L429 331L413 331Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 294L171 352L173 295Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 407L266 420L252 365Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 407L252 365L207 360Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 150L163 211L173 206Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 206L163 211L193 217Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 141L315 130L317 144Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 374L419 356L384 327Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 414L385 374L368 384Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 157L204 159L200 176Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 170L152 150L173 206Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 131L204 159L216 157Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 211L147 254L181 258Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 294L127 316L171 352Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 130L297 126L317 144Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 109L335 130L343 155Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 141L335 130L315 130Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 130L298 123L297 126Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 235L432 210L420 228Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 187L404 162L387 191Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 106L298 123L315 130Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 126L267 119L260 156Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 352L186 385L207 360Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 385L189 389L207 360Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 352L184 385L186 385Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 385L184 385L189 389Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 241L446 235L438 269Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 269L446 235L420 228Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 420L313 432L323 412Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 454L391 414L355 387Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 205L404 162L403 187Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 123L267 119L297 126Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 144L215 131L216 157Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 408L199 407L189 389Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 389L199 407L207 360Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 420L279 439L313 432Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 282L133 287L147 254Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 254L133 287L159 294Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 352L157 370L184 385Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 456L279 439L266 420Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 104L215 131L241 144Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 159L152 150L198 170Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 238L458 241L438 269Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 235L452 205L432 210Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 210L452 205L403 187Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 308L438 269L437 293Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 308L437 293L433 318Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 361L157 370L171 352Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 385L183 408L189 389Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 434L391 414L362 454Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 356L447 350L429 331Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 331L458 342L433 318Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 375L447 350L419 356Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 83L295 106L305 83Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 123L295 106L267 119Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 119L244 104L241 144Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 106L315 130L305 83Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 208L452 205L446 235Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 287L127 316L159 294Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 342L465 308L433 318Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 385L183 408L184 385Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 407L211 429L266 420Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 429L211 429L199 407Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 345L458 342L447 350Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 350L458 342L429 331Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 308L468 238L438 269Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 241L468 238L446 235Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 370L155 385L184 385Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 361L155 385L157 370Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 243L117 282L147 254Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 287L113 293L127 316Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 88L359 109L385 87Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 162L359 109L343 155Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 93L244 104L267 119Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 208L460 202L452 205Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 205L460 202L404 162Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 469L276 456L266 420Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 439L276 456L313 432Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 454L355 387L323 412Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 238L464 208L446 235Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 375L464 345L447 350Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 342L469 341L465 308Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 243L476 211L468 238Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 282L113 293L133 287Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 316L118 329L171 352Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 106L284 93L267 119Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 87L284 93L295 106Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 414L450 375L419 356Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 300L118 329L127 316Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 405L469 341L464 345Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 345L469 341L458 342Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 312L53 289L70 316Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 293L109 300L127 316Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 454L323 412L313 432Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 414L453 403L450 375Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 223L147 254L163 211Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 223L109 243L147 254Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 289L109 300L113 293Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 83L292 87L295 106Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 93L246 60L244 104Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 488L362 454L313 432Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 114L204 159L215 131Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 114L152 150L204 159Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 398L179 429L155 385Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 385L179 429L183 408Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 408L179 429L199 407Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 429L245 469L266 420Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 243L468 238L465 308Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 238L476 211L464 208Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 208L476 211L460 202Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 111L359 109L404 162Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 181L110 223L163 211Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 365L122 361L93 331Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 329L122 361L171 352Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 83L315 130L336 81Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 81L315 130L335 130Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 103L185 114L188 60Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 104L185 114L215 131Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 114L244 104L188 60Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 150L123 181L163 211Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 141L123 181L152 150Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 331L122 361L118 329Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 361L124 398L155 385Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 88L336 81L359 109Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 109L336 81L335 130Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 23L292 87L304 83Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 486L245 469L211 429Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 456L322 488L313 432Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 111L404 162L445 117Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 181L104 215L110 223Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 223L92 227L109 243Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 312L109 300L53 289Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 117L404 162L460 202Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 480L382 458L362 454Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 454L382 458L398 434Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 428L453 403L391 414Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 293L51 279L53 289Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 300L96 312L118 329Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 428L391 414L398 434Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 375L510 405L464 345Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 297L496 243L465 308Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 297L465 308L469 341Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 495L254 476L245 469Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 469L254 476L276 456Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 480L387 459L382 458Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 458L387 459L398 434Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 205L92 227L104 215Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 215L92 227L110 223Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 111L385 87L359 109Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 34L335 37L336 81Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 312L93 331L118 329Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 316L93 331L96 312Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 365L124 398L122 361Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 486L245 495L245 469Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 408L124 398L117 365Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 459L416 448L398 434Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 443L441 428L398 434Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 60L284 93L292 87Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 114L171 103L152 150Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 181L72 205L104 215Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 284L507 297L530 308Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 308L507 297L527 338Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 511L322 488L276 456Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 456L431 443L416 448Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 448L431 443L398 434Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 456L416 448L387 459Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 297L510 253L496 243Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 243L518 197L476 211Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 108L445 117L512 180Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 488L367 480L362 454Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 117L460 202L512 180Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 111L421 77L385 87Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 510L419 456L387 459Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 441L441 428L431 443Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 441L445 436L441 428Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 428L476 413L453 403Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 456L441 441L431 443Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 37L304 83L305 83Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 23L246 60L292 87Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 37L305 83L336 81Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 413L450 375L453 403Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 297L519 284L510 253Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 486L211 429L179 429Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 476L291 511L276 456Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 398L150 449L179 429Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 449L160 458L179 429Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 440L476 413L497 447Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 436L476 413L441 428Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 530L256 500L248 529Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 495L256 500L254 476Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 488L370 491L367 480Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 514L370 491L322 488Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 480L370 491L387 459Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 456L453 488L441 441Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 293L117 282L51 279Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 405L87 408L117 365Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 398L118 449L150 449Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 134L109 141L152 150Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 279L117 282L109 243Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 458L199 486L179 429Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 308L527 276L519 284Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 284L527 276L510 253Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 180L460 202L476 211Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 197L496 243L510 253Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 117L432 85L410 111Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 89L110 134L152 150Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 191L72 205L123 181Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 89L152 150L171 103Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 191L123 181L109 141Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 108L432 85L445 117Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 87L392 56L365 88Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 519L291 511L278 530Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 500L291 511L254 476Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 85L421 77L410 111Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 239L518 197L510 253Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 458L192 489L199 486Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 486L189 510L245 495Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 510L192 489L130 484Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 60L150 89L171 103Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 338L507 297L469 341Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 197L512 180L476 211Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 519L303 514L291 511Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 511L303 514L322 488Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 394L527 338L469 341Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 77L392 56L385 87Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 0L188 60L246 60Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 60L188 60L244 104Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 514L336 514L322 488Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 34L336 81L365 88Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 191L59 221L72 205Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 205L59 221L92 227Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 279L109 243L92 227Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 405L117 365L67 396Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 530L291 511L256 500Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 514L301 519L336 514Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 221L51 279L92 227Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 365L93 331L67 396Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 449L130 484L160 458Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 510L380 508L386 523Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 514L380 508L370 491Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 491L380 508L387 459Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 440L510 405L476 413Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 85L468 56L421 77Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 0L405 0L392 56Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 108L455 86L432 85Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 71L459 91L520 89Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 122L63 191L109 141Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300L43 292L-5 255Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 408L96 423L124 398Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 423L118 449L124 398Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 338L93 331L70 316Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 408L83 405L96 423Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 91L455 86L456 108Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 523L380 508L336 514Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 508L382 510L387 459Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 440L497 447L500 443Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 413L510 405L450 375Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 292L48 320L53 289Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 289L48 320L70 316Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 227L51 279L59 221Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 279L43 292L53 289Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 0L374 34L392 56Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 56L374 34L365 88Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0L267 23L335 37Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 37L267 23L304 83Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 529L256 500L245 495Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 519L297 543L336 514Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 484L192 489L160 458Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 489L189 510L199 486Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 510L248 529L245 495Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 411L524 394L510 405Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 405L524 394L469 341Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 354L556 281L530 308Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 338L67 396L93 331Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 405L67 396L96 423Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 423L115 471L118 449Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 308L556 281L527 276Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 276L556 281L510 253Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 197L534 145L512 180Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 354L530 308L527 338Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 510L443 491L419 456Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 413L445 436L497 447Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 539L386 523L333 559Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 510L405 538L443 491Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 447L445 436L464 488Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 440L530 411L510 405Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 488L453 488L440 532Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 491L453 488L419 456Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 488L445 436L441 441Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 375L527 338L524 394Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 375L544 367L527 338Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 0L155 51L188 60Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 60L155 51L150 89Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 111L83 115L90 89Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 134L83 115L109 141Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 320L37 338L70 316Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 320L37 338L48 320Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 522L115 471L72 514Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 449L115 471L150 449Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 471L130 484L150 449Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 411L542 375L524 394Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 111L90 89L80 106Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 571L297 543L268 573Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 530L297 543L301 519Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 115L110 134L90 89Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 115L68 122L109 141Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 448L499 440L500 443Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 448L530 411L499 440Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 532L453 488L443 491Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 488L464 488L441 441Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 447L534 448L500 443Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 179L534 145L518 197Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 180L524 121L456 108Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 71L468 56L455 86Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 178L27 227L63 191Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 191L27 227L59 221Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 292L0 300L48 320Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 89L110 134L150 89Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 111L68 122L83 115Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 106L68 122L81 111Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 145L528 130L512 180Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 0L335 37L364 0Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 0L308 0L335 37Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 23L245 0L246 60Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 130L524 121L512 180Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0L279 0L267 23Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 41L90 89L150 89Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 81L47 127L68 122Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 0L334 0L335 37Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 37L374 34L364 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 56L432 85L455 86Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 71L455 86L459 91Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 362L564 354L544 367Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 367L564 354L527 338Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 362L544 367L542 375Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 559L386 523L336 514Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 523L405 538L382 510Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 0L245 0L267 23Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 89L459 91L456 108Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 539L405 538L386 523Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 0L364 0L374 34Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 543L181 537L189 510Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 510L216 551L248 529Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 529L252 566L278 530Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 543L189 510L130 484Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 571L333 559L297 543Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 543L333 559L336 514Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 539L426 568L405 538Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 537L216 551L189 510Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 81L68 122L80 106Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 122L47 127L63 191Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 0L206 0L246 60Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 51L118 41L150 89Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 84L520 89L524 121Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 121L520 89L456 108Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 17L421 77L468 56Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 84L524 121L528 130Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 573L237 638L293 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 551L252 566L248 529Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 127L18 178L63 191Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 255L43 292L51 279Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 538L440 532L443 491Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 485L534 448L497 447Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 540L440 532L426 568Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 37L118 41L155 51Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 89L46 81L80 106Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 496L497 447L464 488Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 413L579 362L542 375Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 573L297 543L278 530Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 559L360 580L392 539Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 255L51 279L27 227Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 338L6 369L67 396Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 514L115 471L28 496Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 413L542 375L530 411Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 357L600 271L556 281Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 281L597 239L510 253Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 17L392 56L421 77Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 45L468 56L490 71Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 236L0 237L27 227Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 222L0 236L27 227Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 548L496 496L464 488Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 0L117 37L155 51Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 41L50 73L90 89Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 600L252 566L216 551Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 566L268 573L278 530Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 549L162 543L130 484Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 537L174 550L216 551Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 522L130 484L115 471Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300L0 320L48 320Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 580L342 600L361 594Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 571L334 573L333 559Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 543L174 550L181 537Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 46L486 45L490 71Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 188L0 222L27 227Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 237L0 237L0 236Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 237L-5 255L0 237Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237L-5 255L27 227Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300L-13 277L0 320Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 475L554 433L534 448Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 448L554 433L530 411Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 532L445 540L464 488Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 568L440 532L405 538Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 358L6 369L37 338Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 45L454 17L468 56Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 271L597 239L556 281Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 145L603 119L528 130Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 229L584 179L518 197Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 357L556 281L564 354Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 320L0 358L37 338Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 366L0 358L0 320Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 17L428 0L392 56Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 496L520 485L496 496Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 496L520 485L497 447Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 271L600 238L597 239Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 239L600 229L518 197Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 186L0 188L18 178Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 178L0 188L27 227Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 237L-13 277L-5 255Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 237L0 236L0 222Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 255L-13 277L0 300Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 238L600 229L597 239Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 147L0 186L18 178Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 225L-11 237L0 222Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 147L18 178L47 127Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 225L0 222L0 188Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 496L96 423L0 462Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 543L145 549L174 550Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 548L514 496L496 496Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 432L586 413L554 433Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 0L153 0L155 51Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 600L334 573L292 571Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 573L360 580L333 559Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 522L145 549L130 484Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 608L268 573L252 566Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 -10L443 0L454 17Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 17L443 0L428 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 128L8 147L0 84Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 146L-19 225L0 188Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 81L90 89L50 73Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 362L600 357L579 362Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 362L600 357L564 354Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 73L118 41L117 37Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 209L600 190L584 179Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 179L593 155L534 145Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 89L520 46L490 71Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 413L600 362L579 362Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 413L530 411L554 433Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 240L606 209L600 229Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 229L606 209L584 179Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 240L600 229L600 238Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 240L600 238L600 271Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 240L600 271L626 242Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 146L0 188L0 186Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 237L-19 225L-13 277Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 73L50 73L35 36Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84L8 147L47 127Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 6L50 73L117 37Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 73L49 73L46 81Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 580L426 568L392 539Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 540L488 548L464 488Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 160L584 179L600 190Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 160L593 155L584 179Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 -7L456 -10L454 17Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 475L534 448L520 485Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 84L520 46L520 89Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 366L0 405L6 369Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 369L0 405L67 396Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 429L0 405L-64 366Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 407L0 405L-16 429Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 369L0 358L-64 366Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 405L0 407L67 396Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 600L216 551L207 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 573L293 600L292 571Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 580L413 600L426 568Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 600L360 580L334 573Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 600L324 600L292 571Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 118L600 160L600 190Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 155L603 119L534 145Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 496L115 471L96 423Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 522L129 567L145 549Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 602L328 601L324 600Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 600L328 601L334 573Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 601L342 600L334 573Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 600L360 580L361 594Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 600L435 572L426 568Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 568L435 572L445 540Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 601L328 602L342 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 639L328 602L324 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0L454 17L486 45Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 0L456 -10L428 0Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 -62L344 -54L405 0Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 0L344 -54L364 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 0L344 -54L341 0Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 0L344 -54L334 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 0L344 -54L308 0Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0L297 -63L279 0Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 0L297 -63L245 0Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 -61L168 -33L206 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 0L168 -33L153 0Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 21L473 0L486 45Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 242L600 271L669 346Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 209L664 118L600 190Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 507L558 475L520 485Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 510L520 485L514 496Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0L465 -7L454 17Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -33L112 0L153 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 0L112 0L117 37Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 118L600 146L600 160Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 160L600 146L593 155Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 346L600 271L600 357Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 240L626 242L606 209Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 572L488 548L445 540Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 -62L428 0L456 -10Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 -62L405 0L428 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 584L174 550L145 549Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 600L216 551L174 550Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 638L342 600L328 602Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 -61L206 0L245 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 591L129 567L118 592Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 0L96 6L112 0Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 0L96 6L117 37Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 600L207 600L174 550Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 600L218 608L252 566Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 448L594 432L554 433Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 413L631 399L600 362Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 362L669 346L600 357Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 421L600 420L586 413Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 423L600 421L586 413Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 420L631 399L586 413Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 432L600 423L586 413Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L631 399L600 420Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 -54L297 -63L308 0Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 619L218 608L207 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 600L218 608L214 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 591L133 577L129 567Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 567L133 577L145 549Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 622L413 600L361 594Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 572L458 600L488 548Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 622L361 594L356 638Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 600L413 600L391 622Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 577L140 584L145 549Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 118L603 119L600 146Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 146L603 119L593 155Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 46L531 21L486 45Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 462L96 423L67 396Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 592L129 567L79 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 591L144 600L140 584Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 366L0 320L-13 277Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 407L0 462L67 396Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 594L342 600L356 638Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 600L419 600L426 568Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0L480 -19L465 -7Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 30L531 21L520 46Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 533L552 510L586 564Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 548L552 510L514 496Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 454L600 448L554 433Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 432L600 448L600 423Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 510L555 507L520 485Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 21L480 -19L473 0Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 -7L480 -19L456 -10Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 429L0 462L0 407Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84L47 127L46 81Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 147L-39 146L0 186Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 225L-64 366L-13 277Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84L46 81L0 55Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 454L554 433L558 475Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L600 420L600 421Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 -61L78 0L112 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 6L35 36L50 73Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 600L159 600L140 584Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 584L159 600L174 550Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 55L46 81L49 73Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 516L30 508L28 496Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 496L30 508L72 514Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 458L600 454L558 475Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L600 421L600 423Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 429L0 470L0 462Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 462L0 470L28 496Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 600L210 619L207 600Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 608L237 638L268 573Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 0L35 36L96 6Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 119L593 84L528 130Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 465L600 458L558 475Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L600 423L600 448Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 -63L181 -61L245 0Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 -33L181 -61L112 0Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 591L140 584L133 577Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 600L213 628L210 619Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L600 448L600 454Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 71L-39 146L-21 128Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21 128L-39 146L8 147Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 622L449 600L419 600Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 600L449 600L435 572Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 493L600 465L558 475Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 458L636 427L600 454Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 493L558 475L555 507Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 639L324 600L293 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 79L600 86L664 118Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 119L600 86L593 84Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 84L600 30L520 46Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 567L106 522L79 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 623L213 628L159 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 619L213 628L218 608Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 623L159 600L144 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 30L599 79L654 0Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 86L599 79L593 84Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 600L118 592L79 600Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 591L112 600L144 600Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 600L458 600L435 572Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 533L602 493L555 507Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 622L458 600L449 600Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 638L309 639L293 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 636L237 638L213 628Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 628L237 638L218 608Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 639L356 638L328 602Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 622L548 600L458 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 36L0 55L49 73Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84L-22 78L-21 128Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47L0 55L35 36Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0L35 14L78 0Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 0L35 14L35 36Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 146L-64 366L-19 225Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 429L-22 516L0 470Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 600L106 522L72 514Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 592L112 600L120 591Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 465L636 427L600 458Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 399L669 346L600 362Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L0 47L35 36Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 55L-22 78L0 84Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 71L-22 78L0 55Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 533L555 507L552 510Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 465L662 437L636 427Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 437L669 346L631 399Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 242L664 118L606 209Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 1L558 -1L531 21Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 21L541 -23L480 -19Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 -19L476 -62L456 -10Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 -23L476 -62L480 -19Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 -54L476 -62L297 -63Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L-33 71L0 47Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47L-33 71L0 55Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 78L-33 71L-21 128Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 146L-29 -31L-64 366Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 -1L541 -23L531 21Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 636L119 623L112 600Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 600L119 623L144 600Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 600L43 589L62 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 600L72 514L43 589Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 516L28 496L0 470Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 30L573 1L531 21Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 -1L570 -2L541 -23Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 1L570 -2L558 -1Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 118L600 86L603 119Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 79L600 30L593 84Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 519L662 437L600 465Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 427L662 437L631 399Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 537L594 533L586 564Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 0L0 -62Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 14L0 12L35 36Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0L0 12L35 14Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 366L-22 516L-16 429Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 589L72 514L30 508Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 600L103 636L112 600Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 519L600 465L602 493Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 346L664 118L626 242Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 564L552 510L548 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 533L611 525L602 493Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 566L43 589L30 508Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 537L611 525L594 533Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 -31L0 0L0 -62Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0L0 0L0 12Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L-29 -31L-33 71Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 651L79 600L62 600Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 651L103 636L79 600Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 623L103 636L213 628Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 600L488 548L458 600Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 600L552 510L488 548Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 537L648 519L611 525Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 638L548 600L391 622Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 0L600 0L600 30Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 30L600 0L573 1Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 1L600 0L570 -2Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 -2L600 -43L541 -23Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 -23L600 -43L476 -62Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 578L40 600L43 589Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 589L40 600L62 600Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 516L0 566L30 508Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 0L607 0L600 30Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L600 -43L570 -2Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 0L609 0L600 30Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 0L600 -43L600 0Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 605L562 600L548 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 600L562 600L586 564Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 578L3 578L0 566Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 566L3 578L43 589Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 516L0 578L0 566Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 578L0 600L40 600Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 600L77 651L62 600Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 605L575 600L562 600Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 600L575 600L586 564Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 587L648 519L600 537Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 525L648 519L602 493Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 587L600 537L586 564Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600L77 651L40 600Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 636L77 651L237 638Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 638L77 651L309 639Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 639L77 651L356 638Z",
    fill: "#1f1f1f",
    stroke: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 600L600 587L586 564Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 516L0 600L0 578Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 578L0 600L3 578Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64 366L0 600L-22 516Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 0L600 -43L609 0Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 0L600 -43L607 0Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 605L600 600L575 600Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 600L600 600L600 587Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 587L612 600L648 519Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -62L12 0L78 0Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L-29 -31L0 12Z",
    fill: "#191919",
    stroke: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 71L-29 -31L-39 146Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 -61L0 -62L78 0Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 -63L0 -62L181 -61Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 118L654 0L599 79Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 605L612 600L600 600Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 600L612 600L600 587Z",
    fill: "#1c1c1c",
    stroke: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 638L607 605L548 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBgB);
export default __webpack_public_path__ + "static/media/polyBG_b.9ffc96cbe260ad60a24aca6af82d6760.svg";
export { ForwardRef as ReactComponent };